module.exports = __webpack_public_path__ + "static/media/cwiczenie_5.927b0e10.jpg";